module.exports = __webpack_public_path__ + "img/curtain_horizontal_0.81e214cb.svg";